module.exports = __webpack_public_path__ + "static/media/Digitalinput3-8.075f8ae7.jpg";